window.errorMessageTMX = {
  50800: {
    ar: 'حسابك في خطر ويتم تجميد الأموال الآن. يرجى الاتصال بخدمة العملاء.',
    pt: 'Sua conta está em risco e os fundos estão congelados agora. Por favor, contate o atendimento ao cliente.',
    en: 'Your account is at risk and the funds are frozen now. Please contact customer service.',
    es: 'Tu cuenta se encuentra en riesgo y los fondos están bloqueados por el momento. Por favor, ponte en contacto con nuestro servicio al cliente.',
    id: 'Akun-mu beresiko dan dananya telah diblokir. Silahkan hubungi customer service.',
    ja: 'お客様のアカウントのセキュリティにリスクが存在しているため、一部機能を停止しました。サポートへご連絡ください。',
    tr: 'Hesabın risk altında ve bloke edildi. Lütfen müşteri hizmetleri ile iletişime geç.',
    zh: '您的帳戶處於高風險且資金已被凍結，請與客服聯繫。',
    ru: 'Ваш аккаунт находится в опасности, и средства на нем заблокированы. Обратитесь в службу поддержки.'
  },
  50801: {
    ar: 'حسابك مُعرض للخطر. يرجى الاتصال بخدمة العملاء لدينا.',
    pt: 'Sua conta está em risco. Entre em contato com nosso serviço de atendimento ao cliente.',
    en: 'Your account is at risk. Please contact our customer service.',
    es: 'Tu cuenta está en riesgo. Contacta con nuestro servicio de atención al cliente.',
    id: 'Akun kamu beresiko. Silahkan hubungi layanan pengguna kami.',
    ja: 'お客様のアカウントは現在危険な状況にあります。カスタマーサービスまでご連絡ください。',
    tr: 'Bir hata oluştu. Lütfen Müşteri Hizmetleri ile iletişime geç',
    zh: '您的帳戶存在風險，請聯繫我們的客服。',
    ru: 'Ваш аккаунт в опасности. Свяжитесь с нашей службой поддержки клиентов.'
  },
  50802: {
    ar: 'هناك الكثير من العمليات. الرجاء المحاولة لاحقاً',
    pt: 'Muitas operações. Por favor, tente novamente mais tarde',
    en: 'Too many operations. Please try again later',
    es: 'Demasiadas operaciones. Por favor, inténtelo de nuevo más tarde',
    id: 'Terlalu sering mencoba. Silahkan coba lagi nanti',
    ja: '操作が頻繁しすぎるのため、後ほど再度お試しください。',
    tr: 'Çok fazla işlem. Lütfen daha sonra tekrar dene',
    zh: '操作過度頻繁，請稍後再試',
    ru: 'Слишком много операций. Попробуйте позже'
  }
};
